import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './commons/components/paginator/paginator.component';
import { NgPagination } from './commons/components/paginator/ng-pagination/ng-pagination.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SortIconComponent } from './commons/components/sort-icon/sort-icon.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { SelectComponent } from './commons/components/select/select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NotificationComponent } from './commons/components/notification/notification.component';
import { NotifierComponent } from './commons/components/notifier/notifier.component';

@NgModule({
  declarations: [PaginatorComponent, NgPagination, SortIconComponent, SelectComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule ,InlineSVGModule, NgSelectModule ],
  exports: [PaginatorComponent, NgPagination, SortIconComponent, SelectComponent],
})
export class CoreModule { }
